import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'ff-image-display-modal',
  templateUrl: './image-display-modal.component.html',
  styleUrls: ['./image-display-modal.component.scss']
})
export class ImageDisplayModalComponent implements OnInit {

  /**
   * Array of image sources to display
   */
  @Input() srcs: { src: string, description: string }[] = [];
  
  /**
   * Object to update the parent's title dynamically
   */
  @Input() title: Subject<string>;

  currImage = 0;

  constructor() { }

  ngOnInit(): void {
    this.setTitle();
  }
  
  next() {
    this.currImage = (this.currImage + 1) % this.srcs.length;
    this.setTitle();
  }
  
  prev() {
    this.currImage = (this.srcs.length + this.currImage - 1) % this.srcs.length;
    this.setTitle();
  }
  
  setTitle() {
    const newTitle =
      (this.currImage + 1).toString().padStart(2, '0')
      + '-'
      + (this.srcs.length).toString().padStart(2, '0');

    this.title.next(newTitle);
  }

}
